import { createApp } from "vue";
import { createPinia } from "pinia";
import { WagmiPlugin } from "@wagmi/vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import App from "./App.vue";
import router from "./router";
import { wagmiConfig } from "@/wagmi/config.js";
import "./assets/fonts.css";
import "./assets/base.css";
import "./assets/shell-page.css";
import "./assets/redesign.css";
import "./assets/chrome-premium.css";
import "./assets/side-rails.css";
import "./assets/vault-card-tokens.css";
import "./assets/responsive-premium.css";
import "./assets/mobile-shell.css";
import "./assets/linear-unify.css";
import "./assets/theme-light.css";
import "./assets/theme-mist.css";
import "./assets/theme.css";

const app = createApp(App);
app.use(createPinia());
app.use(router);
window.__FLAP_ROUTER__ = router;
app.use(WagmiPlugin, { config: wagmiConfig });
app.use(VueQueryPlugin, {});
app.mount("#app");
